class Location {
  constructor(data = {}, company = {}) {
    this._id = data._id || data.locationId;
    this.active = data.active || true;
    this.name = data.name || data.locationName;
    this.companyId = data.companyId || company._id;
    this.companyName = data.companyName || company.name;
    this.bannerId = data.bannerId || '';
    this.bannerName = data.bannerName || '';
    this.category = data.category || '';
    this.dmaCode = data.dmaCode || '';
    this.dmaName = data.dmaName || '';
    this.imageUrl = data.imageUrl || null;
    this.address = data.address || {
      line1: data.address1 || '',
      line2: data.address2 || '',
      city: data.city || '',
      country: data.country || '',
      state: data.state || '',
      postalCode: data.postalCode || '',
    };
    this.mediaFormat = data.mediaFormat || '';
    // The selected resolution lives inside displaySettings as a full screen
    // resolution object ({ _id?, name, size: [w, h], custom? }). Older payloads
    // that surface `resolution` / `resolutionSize` at the top level are
    // normalized into this shape in the form hydration layer.
    this.displaySettings = {
      resolution: { name: '', size: [0, 0] },
      screenDimensions: ['', ''],
      screenDiagonal: '',
      screenRotation: 0,
      contentRotation: 0,
      advancedEnabled: false,
      displayAreaDimensions: [0, 0],
      displayAreaPosition: [0, 0],
      ...(data.displaySettings || {}),
    };
    this.playerOnline = data.playerOnline || false;
    this.adNetworkEnabled = data.adNetworkEnabled || false;
    this.adProgramEnabled = data.adProgramEnabled || false;
    this.openExchangeEnabled = data.openExchangeEnabled || false;
    this.tags = data.tags || [];

    // Set address items
    this.address1 = data.address1 || this.address.line1;
    this.address2 = data.address2 || this.address.line2;
    this.city = data.city || this.address.city;
    this.country = data.country || this.address.country;
    this.state = data.state || this.address.state;
    this.postalCode = data.postalCode || this.address.postalCode;
  }
}

export default Location;
